// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f7e2f204","455":"33d9548c","914":"7377b828"}[chunkId] + ".chunk.js";
};